module.exports = __webpack_public_path__ + "static/media/family_icon_orange.b65555a1.svg";